import React from 'react'
import { Button01Icon } from 'src/editor/shared/icons/button-01-icon'
import { Grid01Icon } from 'src/editor/shared/icons/grid-01-icon'
import { PaletteIcon } from 'src/editor/shared/icons/palette-icon'
import { TextInputIcon } from 'src/editor/shared/icons/text-input-icon'
import { Type01Icon } from 'src/editor/shared/icons/type-01-icon'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { websiteStyleSettingsItemLocoKeys } from '../consts'
import { WebsiteStylesSettingsTypeEnum } from '../types'
import { WebsiteStylesSettingsListItem } from './website-style-settings-list-item'

interface WebsiteStylesSettingsListProps {
  setItem: (type: WebsiteStylesSettingsTypeEnum) => void
}

export const WebsiteStylesSettingsList = ({
  setItem,
}: WebsiteStylesSettingsListProps) => {
  const { t } = useTypedTranslation()

  return (
    <>
      <div className="text-heading-4">
        {t('core.header.website_styles_settings.label')}
      </div>
      <div className="mt-6 flex flex-col gap-2">
        <WebsiteStylesSettingsListItem
          label={t(
            websiteStyleSettingsItemLocoKeys[
              WebsiteStylesSettingsTypeEnum.Typography
            ],
          )}
          onClick={() => setItem(WebsiteStylesSettingsTypeEnum.Typography)}
          icon={<Type01Icon />}
        />
        <WebsiteStylesSettingsListItem
          label={t(
            websiteStyleSettingsItemLocoKeys[
              WebsiteStylesSettingsTypeEnum.ThemesAndColors
            ],
          )}
          onClick={() => setItem(WebsiteStylesSettingsTypeEnum.ThemesAndColors)}
          icon={<PaletteIcon />}
        />
        <WebsiteStylesSettingsListItem
          label={t(
            websiteStyleSettingsItemLocoKeys[
              WebsiteStylesSettingsTypeEnum.ButtonsAndLinks
            ],
          )}
          onClick={() => setItem(WebsiteStylesSettingsTypeEnum.ButtonsAndLinks)}
          icon={<Button01Icon />}
        />
        <WebsiteStylesSettingsListItem
          label={t(
            websiteStyleSettingsItemLocoKeys[
              WebsiteStylesSettingsTypeEnum.FormFields
            ],
          )}
          onClick={() => setItem(WebsiteStylesSettingsTypeEnum.FormFields)}
          icon={<TextInputIcon />}
        />
        <WebsiteStylesSettingsListItem
          label={t(
            websiteStyleSettingsItemLocoKeys[
              WebsiteStylesSettingsTypeEnum.Layout
            ],
          )}
          onClick={() => setItem(WebsiteStylesSettingsTypeEnum.Layout)}
          icon={<Grid01Icon />}
        />
      </div>
    </>
  )
}
